// Module
var code = "<input type=\"text\" translate-once-placeholder=\"search\" ng-model=\"vm.search\"\r\n       ng-change=\"vm.change()\" ng-model-options=\"{ debounce: 400 }\" />";
// Exports
module.exports = code;